var toggleHouseholdSubmitButtons;

require('./abo_magazin_company_toggling.js');

toggleHouseholdSubmitButtons = function(e) {
  var mates, toggle, top_toolbar;
  if (e.target.dataset['nestedFormAssocValue'] !== 'members') {
    return;
  }
  mates = document.querySelectorAll('.step-content.active #members_fields .fields:not([style="display: none;"])');
  top_toolbar = document.querySelector('.btn-toolbar.top');
  toggle = function(selector, active) {
    var buttons;
    buttons = Array.from(document.querySelectorAll(selector));
    return buttons.forEach(function(button) {
      if (active) {
        button.type = 'submit';
        return button.classList.remove('d-none');
      } else {
        button.type = 'button';
        return button.classList.add('d-none');
      }
    });
  };
  if (mates.length === 0) {
    toggle('.next-as-single', true);
    toggle('.next-as-family', false);
    if (top_toolbar != null) {
      top_toolbar.classList.add('d-none');
    }
    return $('[data-forwarder-target=click]').click();
  } else {
    toggle('.next-as-single', false);
    toggle('.next-as-family', true);
    return top_toolbar != null ? top_toolbar.classList.remove('d-none') : void 0;
  }
};

document.addEventListener('rails-nested-form:add', toggleHouseholdSubmitButtons);

document.addEventListener('rails-nested-form:remove', toggleHouseholdSubmitButtons);
